<template>
    <div id="content" class="content-margin">
        <div class="root_video_live">
            <div class="title_item_idol">
                <h3 class="titMobile">
                    <img src="../assets/images/ddx.png" alt="">
                    <span>Game</span>
                </h3>
            </div>
            <div class="row">
                <div class="col-md-2 col-sm-2 col-xs-3 wp_item_game" v-for="(item, index) in listgameHeader" :key="index">
                    <div class="item_game">
                        <a :href="item.link" target="_blank">
                            <div class="imgGamePage">
                                <img :src="item.image" alt="">
                            </div>
                            <h3>{{ item.name }}</h3>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Live_nm',
    data () {
        return {
            listgameHeader: [],
            listlinkGk: ''
        }
    },
    components: {
    },
    mounted() {
        
    },
    created () {
        this.getInfoLink()
        setTimeout(() => {
            this.getListGamePage()
        }, 1000);
    },
    methods: {
        getInfoLink () {
            this.axios.get(this.api_previewLink).then((response) => {
                this.listlinkGk = response.data.data.list_data
            })
        },
        getListGamePage () {
            this.listgameHeader = [
                { name: 'Bắn cá', image: require('@/assets/images/game/1.png'), link: this.listlinkGk.fish_shooting },
                { name: 'Casino', image: require('@/assets/images/game/2.png'), link: this.listlinkGk.casino },
                { name: 'Đá gà', image: require('@/assets/images/game/3.png'), link: this.listlinkGk.gamechicken },
                { name: 'E-Sport', image: require('@/assets/images/game/4.png'), link: this.listlinkGk.sport },
                { name: 'Game bài', image: require('@/assets/images/game/5.png'), link: this.listlinkGk.game_3d },
                { name: 'Nổ hũ', image: require('@/assets/images/game/6.png'), link: this.listlinkGk.jackpot },
                { name: 'Xổ số', image: require('@/assets/images/game/7.png'), link: this.listlinkGk.lottery },
                { name: 'Thể thao', image: require('@/assets/images/game/8.png'), link: this.listlinkGk.sport },
            ]
        },
    }
}
</script>
<style>
</style>
